import { getSocket, connectSocket } from "./index";
import { eventBus } from "@/eventBus.js";

function initializeListeners(socket) {
  socket.on("appointments:desk:subscribed", (data) => {
    eventBus.$emit("appointments:desk:subscribed", data);
  });
  socket.on("appointments:scheduled", (data) => {
    eventBus.$emit("appointments:scheduled", data);
  });

  socket.on("appointments:created", (data) => {
    eventBus.$emit("appointments:created", data);
  });
  socket.on("appointments:reconnected", (data) => {
    eventBus.$emit("appointments:reconnected", data);
  });
  socket.on("appointments:in_progress", (data) => {
    eventBus.$emit("appointments:in_progress", data);
  });

  socket.on("appointments:client:entered", (data) => {
    eventBus.$emit("appointments:client:entered", data);
  });
  socket.on("appointments:enter", (data) => {
    eventBus.$emit("appointments:enter", data);
  });

  socket.on("appointments:client:ready", (data) => {
    eventBus.$emit("appointments:client:ready", data);
  });
  socket.on("appointments:leave", (data) => {
    eventBus.$emit("appointments:leave", data);
  });

  socket.on("appointments:client:not_ready", (data) => {
    eventBus.$emit("appointments:client:not_ready", data);
  });

  socket.on("appointments:client:left", (data) => {
    eventBus.$emit("appointments:client:left", data);
  });

  socket.on("appointments:started", (data) => {
    eventBus.$emit("appointments:started", data);
  });

  socket.on("appointments:finished", (data) => {
    eventBus.$emit("appointments:finished", data);
  });

  socket.on("appointments:canceled", (data) => {
    eventBus.$emit("appointments:canceled", data);
  });

  socket.on("appointments:updated", (data) => {
    eventBus.$emit("appointments:updated", data);
  });

  socket.on("appointments:meeting:participant:joined", (data) => {
    eventBus.$emit("appointments:meeting:participant:joined", data);
  });

  socket.on("appointments:meeting:participant:left", (data) => {
    eventBus.$emit("appointments:meeting:participant:left", data);
  });

  socket.on("appointments:transferred", (data) => {
    console.log("appointments:transferred", data);
    eventBus.$emit("appointments:transferred", data);
  });

  socket.on("appointments:no_show", (data) => {
    eventBus.$emit("appointments:no_show", data);
  });
}

export function ensureAppointmentSocketListeners() {
  const socket = getSocket();
  if (socket) {
    initializeListeners(socket);
  } else {
    console.warn("Socket ainda não está conectado. Tentando reconectar...");
    const connectedSocket = connectSocket();
    if (connectedSocket) {
      initializeListeners(connectedSocket);
    }
  }
}

export function enterAppointment({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("appointments:enter", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function startAppointment({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("appointments:start", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function finishAppointment({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("appointments:finish", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function cancelAppointment({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("appointments:cancel", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function noShowAppointment({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("appointments:no-show", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function readyAppointment({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("appointments:ready", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function subscribeDesk({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("appointments:desk:subscribe", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function unsubscribeDesk({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("appointments:desk:unsubscribe", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function joinMeeting({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("appointments:meeting:join", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function leaveMeeting({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("appointments:meeting:leave", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

function removeListeners(socket) {
  socket.off("appointments:desk:subscribed");
  socket.off("appointments:desk:scheduled");
  socket.off("appointments:created");
  socket.off("appointments:client:entered");
  socket.off("appointments:client:ready");
  socket.off("appointments:client:not_ready");
  socket.off("appointments:client:left");
  socket.off("appointments:started");
  socket.off("appointments:finished");
  socket.off("appointments:canceled");
  socket.off("appointments:updated");
  socket.off("appointments:meeting:participant:joined");
  socket.off("appointments:meeting:participant:left");
  socket.off("appointments:transferred");
  socket.off("appointments:no_show");
  socket.off("appointments:reconnected");
  socket.off("appointments:enter");
  socket.off("appointments:in_progress");
}

export function removeAllAppointmentSocketListeners() {
  const socket = getSocket();
  if (socket) {
    removeListeners(socket);
  } else {
    console.warn("Socket não está conectado.");
  }
}
